import React, { useEffect, useState } from 'react';
import { db } from './firebase';
import {
    collection,
    getDocs,
    doc,
    setDoc
} from 'firebase/firestore';

function AdminPage() {
    const [roles, setRoles] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchRoles = async () => {
            const snapshot = await getDocs(collection(db, 'roles'));
            const data = {};
            snapshot.forEach((docSnap) => {
                data[docSnap.id] = docSnap.data().role;
            });
            setRoles(data);
            setLoading(false);
        };

        fetchRoles();
    }, []);

    const handleRoleChange = (uid, newRole) => {
        setRoles((prev) => ({
            ...prev,
            [uid]: newRole
        }));
    };

    const handleSave = async () => {
        for (const uid in roles) {
            await setDoc(doc(db, 'roles', uid), { role: roles[uid] });
        }
        alert('✅ Roles updated!');
    };

    if (loading) return <div className="p-4">Loading...</div>;

    return (
        <div className="p-6 font-sans">
            <h2 className="text-2xl font-bold mb-4">Admin Role Management</h2>
            {Object.entries(roles).map(([uid, role]) => (
                <div key={uid} className="mb-2">
                    <div className="mb-1 font-mono text-sm">UID: {uid}</div>
                    <select
                        value={role}
                        onChange={(e) => handleRoleChange(uid, e.target.value)}
                        className="border p-1 rounded"
                    >
                        <option value="admin">admin</option>
                        <option value="student">student</option>
                    </select>
                </div>
            ))}

            <button
                onClick={handleSave}
                className="mt-4 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            >
                Save
            </button>
        </div>
    );
}

export default AdminPage;
